//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Icon } from 'vant'
import {
  isEmpty,
  isEmptyAll,
  isObject,
} from '@/utils/validator'
import AsyncValidator from 'async-validator'
import { isEqual } from '@/utils/lodash'
import { toast } from '@/utils/toast.js'

export default {
  name: 'CItem',

  components: { Icon },

  inheritAttrs: false,

  props: {
    prefixRender: { type: Function },

    name: {
      type: String,
      required: true,
    },

    tip: { type: String },

    rules: {
      type: [
        Object,
        Array,
      ],
    },

    // valueName: {
    //   type: String,
    //   default: 'key',
    // },

    clear: {
      type: Array,
      default: () => [],
    },

    beforeClear: {
      type: Function,
      default (newValue, oldValue, cb) {
        const r = true

        cb(r)
      },
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    component: {
      type: [
        String,
        Object,
      ],
      default: '',
    },

    componentProps: {
      type: Object,
      default: () => ({}),
    },

    componentEvents: {
      type: Object,
      default: () => ({}),
    },

    value: {
      type: [
        FormData,
        File,
        String,
        Boolean,
        Number,
        Array,
        Object,
        Date,
      ],
    },
  },

  data () {
    return {
      isEmpty,
      events: [],
      skipValidate: false,
      errorMsg: '',
      vm: {},
      originalValue: undefined, // 组件初始化时的值
      currentValue: undefined, // 每次变化后的值
      oldValue: undefined, // 每次变化后的值
    }
  },

  computed: {
    ruleList () {
      let { rules = [] } = this
      rules = isObject(rules) ? [rules] : rules

      return rules
    },

    spanLabel () {
      return this.componentProps?.label || ''
    },

    spanValue () {
      const value = this.componentProps?.value

      if (value in this.$parent?.model && this.$parent.model[value]) {
        return this.$parent.model[value]
      } else {
        return ''
      }
    },

    model: {
      set (v) {
        this.$emit('on-input', v)
      },
      get () {
        return this.value
      },
    },

    errorMessage () {
      return this.errorMsg || ''
    },

    error () {
      return this.errorMessage.length > 0
    },

    required () {
      return this.ruleList.some(({ required }) => required) || this.componentProps?.required
    },
  },

  async mounted () {
    await this.$nextTick()
    this.detect()
  },

  updated () {
    this.detect()
  },

  methods: {
    itemLabelClick () {
      if (this.componentEvents?.['left-click']) {
        this.componentEvents['left-click']()
      }
    },

    onClickLeftIcon () {
      this.$emit('on-click-left-icon')
    },

    onClickRightIcon () {
      this.$emit('on-click-right-icon')
    },

    detect () {
      const vm = this.$children[0]

      if (!vm) {
        return
      }

      if (!isEmpty(this.vm) && this.vm._uid === vm._uid) {
        return
      }

      this.vm = vm

      this.vm.$watch('value', this.handleWatch, { deep: true })
      this.$on('on-clear', this.handleClear)
      this.originalValue = this.currentValue = this.oldValue = this.vm.value
    },

    handleClear (clear) {
      const { name } = this

      if (clear.includes(name)) {
        this.vm.doClear()
      }
    },

    handlerLeftIcon () {
      if (this.componentEvents['left-click']) {
        this.componentEvents['left-click']()

        return
      }

      if (this.tip) {
        toast(this.tip)
      }
    },

    async handleWatch (currentValue, oldValue) {
      this.currentValue = currentValue
      this.oldValue = oldValue

      if (isEqual(currentValue, oldValue) || (isEmptyAll(currentValue) && isEmptyAll(oldValue))) {
        return
      }

      this.validate('change') // 由于新旧值不同或新旧值都不为空, 触发效验
      const {
        $parent: container = {},
        beforeClear,
        name,
        clear,
      } = this

      if (['CForm'].includes(container.$options.name)) {
        const {
          _events: {
            'on-change': hasBindingChangeEvent,
          } = {},
        } = container

        // 在容器组件实例上，手动触发on-change事件, 告知使用者，是谁的值发生了变化
        if (hasBindingChangeEvent) {
          container.$emit('on-change', name, currentValue)
        }

        // 执行清除级联操作
        if (clear.length) {
          if (typeof beforeClear === 'function') {
            const needClear = await new Promise((resolve) => beforeClear(currentValue, oldValue, resolve))

            if (needClear) {
              container.broadcastClear(clear)
            }
          }
        }
      }
    },

    getRules (trigger) {
      const rules = this.ruleList.filter((rule) => {
        return trigger === 'force' ||
          !rule.trigger ||
          rule.trigger.includes(trigger)
      })

      return rules
    },

    async validate (trigger = 'force') {
      if (this.skipValidate) {
        this.skipValidate = false

        return this.errorMessage
      }

      const rules = this.getRules(trigger)

      if (!rules.length) {
        return this.errorMessage
      }

      const result = await this._validate(rules, trigger)

      this.errorMsg = result?.[0]?.message || ''

      if (trigger === 'force') {
        // 调用api方式的效验结果通过return返回
        return this.errorMsg
      } else {
        // 触发change事件导致的效验的结果通过事件发送出去

        this.$emit('on-validate', this.errorMsg)

        // return this.errorMsg
      }
    },

    async _validate (rules, trigger) {
      const model = this.$parent?.model || {}
      const lazy = this.$parent?.model || {}
      const renderData = this.$parent?.renderData || []
      const { name } = this
      const descriptor = { [name]: rules }
      const value = lazy
        ? this.currentValue === undefined
          ? model[name]
          : this.currentValue
        : this.currentValue

      const data = {
        [name]: value,
        model,
        renderData,
        validateList: this.$parent?.getValidateList?.(),
        trigger,
      }

      const validator = new AsyncValidator(descriptor)

      return new Promise((resolve) => {
        return validator.validate(data, { firstFields: true }, resolve)
      })
    },
  },
}
